import { type ReactNode } from 'react'

import { RichCardCarousel } from '@/features/listing/components/rich-card/rich-card-media/RichCardCarousel'
import { RichCardImagePanel } from '@/features/listing/components/rich-card/rich-card-media/RichCardImagePanel'
import { type GenericListing } from '@/features/listing/types/listings'

export type RichCardMediaProps = {
  index: number
  listing: GenericListing
  mediaType: 'image' | 'carousel'
  titleOverride?: string | ReactNode
}

export const RichCardMedia = ({ index, listing, mediaType, titleOverride }: RichCardMediaProps) => {
  const { imageUrls } = listing

  if (mediaType === 'carousel') {
    return <RichCardCarousel listing={listing} titleOverride={titleOverride} />
  }

  return <RichCardImagePanel listing={listing} imageUrl={imageUrls[0] || null} index={index} />
}
